import React from "react";

import KokaMenu from "./KokaMenuComponent";

import {
	kokaMenuNonCoffe,
	kokaMenuCoffe,
	menuCoca,
	menuLowcost,
} from "./dataKokaMenu";

const Menus = () => {
	return (
		<>
			<KokaMenu id="kokamenu" dataMenu={kokaMenuCoffe} label={"Coffee"} />
			<KokaMenu
				dataMenu={kokaMenuNonCoffe}
				label={"Non Coffee"}
				id="kokamenu"
			/>
			<KokaMenu id="cocamenu" dataMenu={menuCoca} label={"Cookies"} />
			<KokaMenu
				id="lowcostmenu"
				dataMenu={menuLowcost}
				label={"Low Cost"}
			/>
		</>
	);
};

export default Menus;
